import React, { Component } from "react"
// eslint-disable-line no-unused-vars
import renderHTML from "react-render-html"
import "./_spot-button.scss"

class SpotButton extends Component {
  static defaultProps = {
    imageUrlMobile: "", //'/static/newshop/img3.png',
    ImageUrl: "", //'/static/newshop/img2.png',
    ImageAltText: "",
    Title: "",
    SmallTitle: false,
    LinkUrl: "#",
    LinkTarget: "_self",
    Description: "", //'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Recusandae dolorum, officia beatae in quae cumque inventore, deserunt laborum, obcaecati sed quidem possimus ipsum odit, impedit reiciendis reprehenderit. Natus, itaque, laudantium.'
  }

  render() {
    let headlineSnippet = ""
    if (this.props.SmallTitle) {
      headlineSnippet = (
        <div className="spot-button__text__headline">
          {" "}
          <h5>{this.props.Title}</h5>{" "}
        </div>
      )
    } else if (this.props.Title) {
      headlineSnippet = (
        <div className="spot-button__text__headline">
          {" "}
          <h3>{this.props.Title}</h3>{" "}
        </div>
      )
    }

    return (
      <a className="spot-button" href={this.props.LinkUrl} target={this.props.LinkTarget}>
        <div className="spot-button__image">
          <picture>
            <source srcSet={this.props.ImageUrl} media="(max-width: 767px)" />
            <source srcSet={this.props.ImageUrl} media="(min-width: 767px)" />
            <img src={this.props.ImageUrl} alt={this.props.ImageAltText} />
          </picture>
        </div>

        <div className="spot-button__text">
          {headlineSnippet}

          {this.props.Description && <div className="spot-button__text__bodytext">{renderHTML(this.props.Description)}</div>}
        </div>
      </a>
    )
  }
}

export default SpotButton
